export const touch = {
  bind(el, binding) {
    const handler = binding.value;
    const sensitivity = 10;
    const maxWidth = 1024;

    let enabled = false;
    let startX = null;
    let moved = false;

    const getPoint = (e) =>
      e.touches ? e.touches[0].clientX : e.clientX;

    const onStart = (e) => {
      if (!enabled) return;
      startX = getPoint(e);
      moved = false;
    };

    const onMove = (e) => {
      if (!enabled || startX === null) return;
      const currentX = getPoint(e);
      const deltaX = currentX - startX;

      if (Math.abs(deltaX) < sensitivity) {
        if (moved) handler(0);
        return;
      }

      moved = true;
      e.preventDefault();
      handler(deltaX);
    };

    const onEnd = () => {
      if (!enabled) return;
      if (!moved) handler(0);
      else handler('end');
      startX = null;
      moved = false;
    };

    const enableListeners = () => {
      el.addEventListener('touchstart', onStart, { passive: true });
      el.addEventListener('touchmove', onMove, { passive: false });
      el.addEventListener('mousedown', onStart);
      el.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onEnd);
      window.addEventListener('touchend', onEnd);
    };

    const disableListeners = () => {
      el.removeEventListener('touchstart', onStart);
      el.removeEventListener('touchmove', onMove);
      el.removeEventListener('mousedown', onStart);
      el.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onEnd);
      window.removeEventListener('touchend', onEnd);
    };

    const checkAndUpdate = () => {
      const shouldEnable = window.innerWidth <= maxWidth;
      if (shouldEnable && !enabled) {
        enableListeners();
        enabled = true;
      } else if (!shouldEnable && enabled) {
        disableListeners();
        enabled = false;
      }
    };

    el._resizeListener = checkAndUpdate;

    checkAndUpdate();
    window.addEventListener('resize', el._resizeListener);
  },

  unbind(el) {
    window.removeEventListener('resize', el._resizeListener);
    el._resizeListener = null;
  }
};

